import { Domain as DomainType } from 'Types/Domain'
import {
  Connected,
  DisabledProduct,
  MonitoringWrapper,
  TableText,
} from 'Features/domainsManagement/components/DomainManagmentRow/DomainManagementRow.styled'
import { Setup } from 'Features/domainsManagement/components/Setup/Setup'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Toggle } from '@clickcease/cc-client-components-lib'
import { useUserStore } from 'Stores/userStoreModuleFed'

type BotMitigationButtonProps = {
  domain: DomainType
  openBotMitigationModal: () => void
  updateDomainBzMonitorMode?: () => void
  disabled?: boolean
}

export const BotMitigationButton = ({
  domain,
  openBotMitigationModal,
  updateDomainBzMonitorMode,
  disabled,
}: BotMitigationButtonProps) => {
  const { t } = useTranslation('domainManagement')
  const { owner } = useUserStore()

  const bmDomainWithNoWordpress =
    domain.botZapping &&
    domain.tagInstalled &&
    !domain.wordpress &&
    !domain.botZappingPluginActivated

  if (domain.botZapping) {
    return domain.botZappingConnected || bmDomainWithNoWordpress ? (
      <>
        <Connected>{t('connected')}</Connected>
        {domain.botZappingPluginActivated ? (
          <MonitoringWrapper>
            <Toggle
              disabled={!owner}
              value={domain.isBzMonitor}
              onChange={updateDomainBzMonitorMode}
            />
            <TableText>{t('monitoring_mode')}</TableText>
          </MonitoringWrapper>
        ) : null}
      </>
    ) : (
      <Setup disabled={disabled} onClick={() => openBotMitigationModal()} />
    )
  } else {
    return <DisabledProduct>{t('disabled')}</DisabledProduct>
  }
}
